import './SettingsFilterZip.scss'

import React, {Component} from 'react';
import { Button } from 'react-bootstrap'
import { replace } from 'react-router-redux'

import {validateZipcode, addZipFilter, removeZipFilter} from 'manager/redux/settings'
import { getMetroFromZip } from 'manager/util/helper'
import SpeedBumpBanner from '../ReferralStatus/Common/SpeedBumpBanner';

const doValidate = _.debounce((that, zipcode) => {
    that.props.dispatch(validateZipcode(zipcode, null, true))
    .then((response)=>{
      that.setState({...response, isValidating: false})
    })
}, 800)

class SettingsFilterZip extends Component {
  constructor(props) {
    super(props)

    this.state = {
      filter_zip: null,
      isValidating: false,
      isDirty: false,
      exists: false,
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleChange(e) {
    this.setState({
      filter_zip: e.target.value,
      isDirty: true,
      isValidating: true
    })
    doValidate(this, e.target.value)
  }

  handleSubmit() {
    this.props.dispatch(addZipFilter(this.state.filter_zip))
    .then(()=>{
      this.setState({
        filter_zip: null,
        isValidating: false,
        exists: false,
      })
    })
  }

  render() {
    const isEmerging = this.props.auth.user.agent_experience_level === 'emerging'
    const shouldShowNotExists = this.state.filter_zip && !this.state.isValidating && this.state.isDirty && !this.state.exists
    const shouldShowValidated =  this.state.filter_zip && !this.state.isDirty || (!this.state.isValidating && this.state.exists)

    const validatedZipcodeRight = shouldShowValidated ? <div className="SettingsLocation__input__right">{ this.state.filter_zip_metro }</div> : null
    const validatedZipcodeLeft = shouldShowValidated ? <div className="SettingsLocation__input__left"><i className="fa fa-check" aria-hidden="true"></i> Valid</div> : null
    const invalidZipcodeLeft = shouldShowNotExists ? <div className="SettingsLocation__input__left SettingsLocation__input__left--danger"><i className="fa fa-times" aria-hidden="true"></i> Not Valid</div> : null
    const notExistsZipcode = shouldShowNotExists ? "This zip code could not be found" : null

    const blockedZipSection = (this.props.settings.blocked_zipcodes && this.props.settings.blocked_zipcodes.length > 0) ? <div className="SettingsFilterZip__blocked-zips">
      <div className="Settings__label">DISABLED ZIP CODES</div>
      <div className="SettingsFilterZip__blocked-zips-list">
        { this.props.settings.blocked_zipcodes.map((zip, idx)=>{
          return (<div className="SettingsFilterZip__blocked-zips-list-item" key={idx}>
            <div className="SettingsFilterZip__blocked-zips-list-item-label">{zip.name} - {getMetroFromZip(zip)}</div>
            <button className="SettingsFilterZip__blocked-zips-list-item-action SettingsFilterZip__icon SettingsFilterZip__icon--remove" onClick={()=>{this.props.dispatch(removeZipFilter(zip.name))}} />
          </div>)
        })}
      </div>
    </div> : null

    return <div className="SettingsFilterZip">
        {this.props.settings.is_location_overridden && (
            <SpeedBumpBanner
                headlineText="You may receive Market VIP leads that don’t match your location preferences"
                bodyText="Your broker can change your location preferences for leads purchased through Market VIP. If there is ever an issue, please reach out to your broker."
                type="warning"
            />
        )}
      { isEmerging ? <div className="SettingsHome__emerging">
        <div>
          <div/>
          <div>As an <strong>emerging agent,</strong> you must <strong>close 1 client</strong> before you can disable zipcodes.</div>
        </div>
      </div> : null }
      <div className="SettingsFilterZip__desc">Add zip codes of areas within your coverage area where you do not want to receive referrals</div>

    <div className="SettingsFilterZip__input">
        <input placeholder="Add a zip code to disable" maxLength="5" type="number" value={this.state.filter_zip} onChange={this.handleChange} disabled={isEmerging} />
        { validatedZipcodeLeft }
        { validatedZipcodeRight }
        { invalidZipcodeLeft }
      </div>

      <div className="SettingsFilterZip__error">
        { notExistsZipcode ?
          <div>
            { notExistsZipcode }
          </div> : null }
      </div>

      <div className="SettingsFilterZip__btn">
        <Button bsStyle="primary" disabled={!shouldShowValidated} onClick={this.handleSubmit}><i className="fa fa-plus" aria-hidden="true" /> Disable Zip Code</Button>
      </div>
      { this.props.settings.bulk_add_filter_zip ?
          <div className="SettingsFilterZip__browse">
            <a onClick={() => this.props.dispatch(replace({pathname:'/settings/blocked-zipcodes-area'}))} ><i className='fa fa-search'/><span>Browse Zip Codes in your Coverage Area</span></a>
          </div>
      : null }
      { blockedZipSection }

      { this.props.settings.blocked_zipcodes && this.props.settings.blocked_zipcodes.length >= 3 ?
        <div className="SettingsFilterZip__warning">
          <i className="fa fa-exclamation-triangle" aria-hidden="true" />
          <div className="SettingsFilterZip__warning-text">Adding too many zip codes could severely limit the number of referrals you receive</div>
        </div>
      : null }
    </div>
  }
}

export default SettingsFilterZip
